import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';
export function isInternalLink() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '' : _ref$href;
  return href.startsWith('/');
}
export function getLabel(href, rest) {
  var label = _get(rest, 'label', '');
  var children = _get(rest, 'children', '');
  if (!_isEmpty(label)) {
    return label;
  }
  if (_isString(children) && !_isEmpty(children)) {
    return children;
  }
  if (_isArray(children) && !_isEmpty(children)) {
    var childrenText = children.map(function (child) {
      if (_isString(child)) {
        return child;
      }
      return '';
    }).filter(function (child) {
      return !_isEmpty(child);
    }).join(' - ');
    if (!_isEmpty(childrenText)) {
      return childrenText;
    }
  }
  return href;
}